import { render } from "./CosmeticDentistry.vue?vue&type=template&id=0bcbf2fd&scoped=true"
import script from "./CosmeticDentistry.vue?vue&type=script&lang=js"
export * from "./CosmeticDentistry.vue?vue&type=script&lang=js"

import "./CosmeticDentistry.vue?vue&type=style&index=0&id=0bcbf2fd&scoped=true&lang=css"

import exportComponent from "/Users/alialsaady/Documents/repos/tandzorggestel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bcbf2fd"]])

export default __exports__